import {CONDITIONAL_DISALLOWED_PATHS, WILDCARD} from './constants/values'

export function checkConditionalDisallowedPaths(errorType: string, path: Array<string | number>) {
  const disallowedPaths = CONDITIONAL_DISALLOWED_PATHS[errorType]
  if (!disallowedPaths) {
    return false
  }

  for (const disallowedPath of disallowedPaths) {
    if (path.length !== disallowedPath.length) continue

    let foundMatchingPath = true
    for (let i = 0; i < path.length; i++) {
      if (path[i] !== disallowedPath[i] && disallowedPath[i] !== WILDCARD) {
        foundMatchingPath = false
        break
      }
    }
    if (foundMatchingPath) {
      return false
    }
  }

  return true
}
